export enum Settings {
    FT1_35301_NEXUS_BASKET_CHANGED = 'FT1_35301_NEXUS_BASKET_CHANGED'
}

export class SettingsService {
    private readonly settings: string[];

    constructor() {
        this.settings = this.initSettings();
    }

    private initSettings(): string[] {
        const settingsPerClass = document.getElementsByClassName('or_js_settings');
        let settingsElement;
        if (settingsPerClass.length > 0) {
            settingsElement = settingsPerClass[settingsPerClass.length - 1];
        }
        const settingsString = settingsElement?.getAttribute('data-settings') ?? '';

        return settingsString.split(',');
    }

    isEnabled(settingName: string): boolean {
        return this.settings.includes(settingName);
    }
}
